import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { ActionLabels, MarketplaceItemStatus, TermsAndCondtion, MarketplaceQuery, ErrorStateService, CartQuery, CartService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { takeUntil, mergeMap, tap, map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MarketplacePurchaseConfirmationComponent } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details/marketplace-purchase-confirmation';
import { CartModalComponent } from '@fgb/portal-component-library/src/lib/loyalty/cart-item/cart-modal';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { NumberInputModule } from '@fgb/portal-component-library/src/lib/shared/number-input';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/shared/errors';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@fgb/portal-component-library/src/lib/shared/number-input';
import * as ɵngcc7 from 'ng-inline-svg';
import * as ɵngcc8 from '@ngx-translate/core';

function MarketplaceActionsComponent_div_1_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "fgbcl-number-input", 7);
    ɵngcc0.ɵɵlistener("amountChange", function MarketplaceActionsComponent_div_1_div_1_ng_container_1_Template_fgbcl_number_input_amountChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.purchaseQuantity = $event; })("amountChange", function MarketplaceActionsComponent_div_1_div_1_ng_container_1_Template_fgbcl_number_input_amountChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.updatePurchaseValidation(ctx_r9.marketplaceItem); });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const limitMessage_r5 = ɵngcc0.ɵɵnextContext().ngSubscribe;
    const purchaseLimit_r1 = ɵngcc0.ɵɵnextContext().ngSubscribe;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("isActive", ctx_r6.isNumberInputActive(purchaseLimit_r1))("minValue", purchaseLimit_r1 > 0 ? 1 : 0)("maxValue", purchaseLimit_r1)("incrementValue", 1)("minMessage", "1 minimum")("maxMessage", ɵngcc0.ɵɵpipeBind1(2, 8, limitMessage_r5))("amount", ctx_r6.purchaseQuantity)("theme", ctx_r6.marketplaceItem.theme);
} }
function MarketplaceActionsComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, MarketplaceActionsComponent_div_1_div_1_ng_container_1_Template, 3, 10, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.marketplaceItem.Status == ctx_r2.marketplaceItemStatus.Available);
} }
function MarketplaceActionsComponent_div_1_div_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "button", 13);
    ɵngcc0.ɵɵlistener("click", function MarketplaceActionsComponent_div_1_div_2_ng_container_5_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.addProductToCart(); });
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelement(4, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 15);
    ɵngcc0.ɵɵlistener("click", function MarketplaceActionsComponent_div_1_div_2_ng_container_5_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.addProductToCart(true); });
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelement(7, "div", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const disableCart_r12 = ɵngcc0.ɵɵnextContext().ngSubscribe;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", disableCart_r12);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(3, 6, "cart.add.item.screenreader"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("inlineSVG", "assets/images/icons/add-to-basket.svg");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", disableCart_r12);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(6, 8, "cart.add.item.screenreader"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("inlineSVG", "assets/images/icons/add-to-basket.svg");
} }
function MarketplaceActionsComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "button", 10);
    ɵngcc0.ɵɵlistener("click", function MarketplaceActionsComponent_div_1_div_2_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.openPurchaseConfirmationModal("confirmContent"); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, MarketplaceActionsComponent_div_1_div_2_ng_container_5_Template, 8, 10, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const disableCart_r12 = ctx.ngSubscribe;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", disableCart_r12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 3, ctx_r3.statusText), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("fgbWebsiteContentFeatureFlag", "feature.flag.cart.show");
} }
function MarketplaceActionsComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 16);
    ɵngcc0.ɵɵlistener("click", function MarketplaceActionsComponent_div_1_div_3_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.openPurchaseConfirmationModal("confirmContentCardPayment"); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const purchaseLimit_r1 = ɵngcc0.ɵɵnextContext().ngSubscribe;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.isEcashButtonDisabled(purchaseLimit_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 2, "marketplace.buy.with.card"), " ");
} }
function MarketplaceActionsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, MarketplaceActionsComponent_div_1_div_1_Template, 2, 1, "div", 3);
    ɵngcc0.ɵɵtemplate(2, MarketplaceActionsComponent_div_1_div_2_Template, 6, 5, "div", 4);
    ɵngcc0.ɵɵtemplate(3, MarketplaceActionsComponent_div_1_div_3_Template, 4, 4, "div", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSubscribe", ctx_r0.limitMessage$);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSubscribe", ctx_r0.disableCart$);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasECash);
} }
class MarketplaceActionsComponent {
    constructor(marketplaceQuery, errorService, modalService, cartQuery, cartService) {
        this.marketplaceQuery = marketplaceQuery;
        this.errorService = errorService;
        this.modalService = modalService;
        this.cartQuery = cartQuery;
        this.cartService = cartService;
        this.validCustomFields = [];
        this.actionLabels = ActionLabels;
        this.purchaseLoading = new EventEmitter(false);
        this.hasSumbittedForm = new EventEmitter(false);
        this.cardTokenCount = 0;
        this._acceptedTerms = false;
        this.purchaseQuantity = 1;
        this.marketplaceItemStatus = MarketplaceItemStatus;
        this._destroyed$ = new Subject();
    }
    ngOnInit() {
        this._setUpLocalVariables();
        this.updatePurchaseData();
    }
    updateTermsAndCondtions(accepted) {
        this._acceptedTerms = accepted;
        this.updatePurchaseValidation(this.marketplaceItem);
    }
    updateCustomFields(customFields) {
        this.validCustomFields = customFields;
        this.updatePurchaseValidation(this.marketplaceItem);
    }
    updatePurchaseData(purchaseQuantity, attributeMappingID) {
        if (purchaseQuantity) {
            this.purchaseQuantity = purchaseQuantity;
        }
        if (attributeMappingID) {
            this.attributeMappingID = attributeMappingID;
        }
        this._updatePurchaseLimit();
        this.updatePurchaseValidation(this.marketplaceItem);
    }
    _setUpLocalVariables() {
        this.originalStatus = this.marketplaceItem.Status;
        this.marketplaceTerms = new TermsAndCondtion(this.marketplaceItem.TermsAndConditions, this.marketplaceItem.ShowTermsAndConditions, this.marketplaceItem.TermsAndConditionsType);
    }
    _updateItemLocalStatus(purchaseLimit) {
        let cartItemQty = this.cartQuery.getCartItemPurchaseQuantity(this.marketplaceItem.Id, this.attributeMappingID);
        if (this.availableStock < 1 && this.originalStatus == MarketplaceItemStatus.Available) {
            this.marketplaceItem.Status = MarketplaceItemStatus.SoldOut;
        }
        else if (this._isMaxStockInBasket(cartItemQty) || this._isLimitReachedInBasket(cartItemQty, purchaseLimit)) {
            this.marketplaceItem.Status = MarketplaceItemStatus.AllInBasket;
        }
        else {
            this.marketplaceItem.Status = this.originalStatus;
        }
        this._updateStatusText(this.marketplaceItem);
    }
    _isMaxStockInBasket(cartItemQty) {
        const mustCompare = !!this.availableStock && !!cartItemQty;
        const availableStockLocal = this.availableStock - cartItemQty;
        const isAboveLocalStock = this.purchaseQuantity > availableStockLocal;
        return mustCompare && isAboveLocalStock;
    }
    _isLimitReachedInBasket(cartItemQty, purchaseLimit) {
        let availableLimit;
        let isAboveLimit = false;
        if (purchaseLimit) {
            availableLimit = purchaseLimit - cartItemQty;
            isAboveLimit = this.purchaseQuantity > availableLimit;
        }
        return isAboveLimit;
    }
    _updateStatusText(marketplaceItem) {
        switch (marketplaceItem.Status) {
            case MarketplaceItemStatus.SoldOut:
                this.statusText = 'marketplace.redeem.sold.out';
                break;
            case MarketplaceItemStatus.NotEnoughPoints:
                this.statusText = 'marketplace.redeem.not.enough.points';
                break;
            case MarketplaceItemStatus.ComingSoon:
                this.statusText = 'marketplace.redeem.coming.soon';
                break;
            case MarketplaceItemStatus.MemberLimitReached:
                this.statusText = 'marketplace.redeem.member.limit';
                break;
            case MarketplaceItemStatus.AllInBasket:
                this.statusText = 'marketplace.redeem.all.in.basket';
                break;
            default:
                if (this.marketplaceItem.theme === 'mp-event' || this.marketplaceItem.theme === 'mp-virtual-event') {
                    this.statusText = 'marketplace.redeem.event';
                }
                else if (this.marketplaceItem.theme === 'mp-product') {
                    this.statusText = 'marketplace.redeem.product';
                }
                else {
                    this.statusText = 'marketplace.redeem.marketplace';
                }
        }
    }
    _updatePurchaseLimit() {
        this.purchaseLimit$ = this.marketplaceQuery.selectPurchaseLimit(this.marketplaceItem.Id, undefined, this.attributeMappingID);
        this.limitMessage$ = this.marketplaceQuery.selectPurchaseLimitMessage(this.marketplaceItem.Id, undefined, this.attributeMappingID);
    }
    updatePurchaseValidation(item) {
        this.disableCart$ = this.cartQuery.selectMemberMarketplaceCartItem(item.Id, this.attributeMappingID).pipe(takeUntil(this._destroyed$), mergeMap((currentCartItem) => {
            return this.purchaseLimit$.pipe(tap((purchaseLimit) => this._updateItemLocalStatus(purchaseLimit)), map((purchaseLimit) => {
                const currentCartItemQuantity = currentCartItem ? currentCartItem.purchaseQuantity : 0;
                const assumedPurchaseQuantity = this.purchaseQuantity + currentCartItemQuantity;
                const cartQuantityExceedsStock = currentCartItem && assumedPurchaseQuantity > this.availableStock;
                const cartQuantityExceedsLimit = currentCartItem && assumedPurchaseQuantity > purchaseLimit;
                const isUnavailable = item.Status !== MarketplaceItemStatus.Available;
                const insufficientQuantity = purchaseLimit <= 0 || this.purchaseQuantity < (purchaseLimit > 0 ? 1 : 0);
                const isCartDisabled = isUnavailable ||
                    insufficientQuantity ||
                    cartQuantityExceedsStock ||
                    cartQuantityExceedsLimit ||
                    (item.ShowTermsAndConditions && !this._acceptedTerms) ||
                    (item.CustomFields && !this.validCustomFields);
                return isCartDisabled;
            }));
        }));
    }
    addProductToCart(openCartModal) {
        this.errorService.clearErrors();
        let purchaseLimit = 0;
        this.purchaseLimit$.subscribe((x) => (purchaseLimit = x)).unsubscribe();
        let cartPurchaseQty = this.cartQuery.getCartItemPurchaseQuantity(this.marketplaceItem.Id, this.attributeMappingID);
        this.hasSumbittedForm.emit(true);
        if (this.marketplaceItem.CustomFields && !this.validCustomFields)
            return;
        if (!!cartPurchaseQty) {
            if (this._isMaxStockInBasket(cartPurchaseQty)) {
                this.errorService.addError('You have added the maximum stock to your basket');
                return;
            }
            else if (this._isLimitReachedInBasket(cartPurchaseQty, purchaseLimit)) {
                this.errorService.addError('Limit Reached');
                return;
            }
            else {
                this.addItemToCartService();
            }
        }
        else if (this.purchaseQuantity > this.availableStock) {
            this.errorService.addError('Sold Out');
            return;
        }
        else {
            if (this.marketplaceItem.ShowTermsAndConditions && !!this.marketplaceItem.TermsAndConditions) {
                this.openPurchaseConfirmationModal('confirmContent', true, openCartModal);
            }
            else {
                this.addItemToCartService();
                if (openCartModal) {
                    this.openCartModal();
                }
            }
        }
    }
    openCartModal() {
        const unvalidCustomFields = this.marketplaceItem.CustomFields && !this.validCustomFields;
        if (unvalidCustomFields)
            return;
        this.modalService.open(CartModalComponent);
    }
    openPurchaseConfirmationModal(templateName, addToCart, openCartModal) {
        this.hasSumbittedForm.emit(true);
        const unvalidCustomFields = this.marketplaceItem.CustomFields && !this.validCustomFields;
        if (unvalidCustomFields)
            return;
        const modal = this.modalService.open(MarketplacePurchaseConfirmationComponent, {
            ariaLabelledBy: 'modal-basic-title',
            centered: true,
        });
        modal.componentInstance.templateSelected = templateName;
        modal.componentInstance.marketplaceItem = this.marketplaceItem;
        modal.componentInstance.marketplaceItemType = this.marketplaceItemType;
        modal.componentInstance.attributeMappingID = this.attributeMappingID;
        modal.componentInstance.selectedAttributes = this.selectedAttributes;
        modal.componentInstance.purchaseQuantity = this.purchaseQuantity;
        modal.componentInstance.validCustomFields = this.validCustomFields;
        modal.componentInstance.purchaseLoading.pipe(takeUntil(this._destroyed$)).subscribe((loadingState) => {
            this.purchaseLoading.emit(loadingState);
            if (!loadingState) {
                this.modalService.dismissAll();
            }
        });
        if (addToCart) {
            modal.componentInstance.addToCart = true;
            modal.componentInstance.addToCartTermsConfirmed.pipe(takeUntil(this._destroyed$)).subscribe((termsConfirmed) => {
                if (termsConfirmed) {
                    this.addItemToCartService();
                    if (openCartModal) {
                        this.openCartModal();
                    }
                }
            });
        }
    }
    isNumberInputActive(purchaseLimit) {
        return purchaseLimit > 1 || this.marketplaceItem.Status != MarketplaceItemStatus.Available;
    }
    isEcashButtonDisabled(purchaseLimit) {
        return purchaseLimit <= 0 || this.marketplaceItem.Status != MarketplaceItemStatus.Available;
    }
    addItemToCartService() {
        const attributeCart = {
            AttributeMappingId: this.attributeMappingID,
            LocalAttributes: this.selectedAttributes,
        };
        this.cartService.addMarketplaceItemToCart(this.marketplaceItem, this.purchaseQuantity, attributeCart, this.validCustomFields);
    }
    ngOnDestroy() {
        this._destroyed$.next();
        this._destroyed$.complete();
    }
}
MarketplaceActionsComponent.ɵfac = function MarketplaceActionsComponent_Factory(t) { return new (t || MarketplaceActionsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MarketplaceQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ErrorStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CartQuery), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CartService)); };
MarketplaceActionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MarketplaceActionsComponent, selectors: [["fgbcl-marketplace-actions"]], inputs: { validCustomFields: "validCustomFields", actionLabels: "actionLabels", attributeMappingID: "attributeMappingID", marketplaceItem: "marketplaceItem", marketplaceItemType: "marketplaceItemType", selectedAttributes: "selectedAttributes", hasECash: "hasECash", theme: "theme", availableStock: "availableStock" }, outputs: { purchaseLoading: "purchaseLoading", hasSumbittedForm: "hasSumbittedForm" }, decls: 3, vars: 1, consts: [[1, "row", "ml-0"], ["class", "d-flex pl-0 p-0", 4, "ngSubscribe"], [1, "d-flex", "pl-0", "p-0"], ["class", "mb-3 mb-lg-0 justify-content-center align-items-center", 4, "ngSubscribe"], ["class", "d-flex", 4, "ngSubscribe"], [4, "ngIf"], [1, "mb-3", "mb-lg-0", "justify-content-center", "align-items-center"], [3, "isActive", "minValue", "maxValue", "incrementValue", "minMessage", "maxMessage", "amount", "theme", "amountChange"], [1, "d-flex"], [1, ""], ["id", "purchase-now-button", 1, "btn", "btn-marketplace-redeem", "btn-block", "font-weight-bold", "text-nowrap", "px-4", "mt-lg-0", 3, "disabled", "click"], [4, "fgbWebsiteContentFeatureFlag"], [1, "text-right"], ["id", "desktop-addtocart-button", 1, "btn", "btn-marketplace-cart", "mt-4", "px-2", "mt-lg-0", "d-none", "d-lg-block", 3, "disabled", "click"], [1, "svg", "svg-primary", "basket-icon", 3, "inlineSVG"], ["id", "mobile-addtocart-button", 1, "btn", "btn-marketplace-cart", "mt-4", "px-2", "mt-lg-0", "d-lg-none", 3, "disabled", "click"], ["id", "ecash-button", 1, "btn", "btn-warning", "btn-block", "font-weight-bold", 3, "disabled", "click"]], template: function MarketplaceActionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MarketplaceActionsComponent_div_1_Template, 4, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(2, "fgbcl-errors");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSubscribe", ctx.purchaseLimit$);
    } }, directives: [ɵngcc3.NgSubscribeDirective, ɵngcc4.ErrorsComponent, ɵngcc5.NgIf, ɵngcc6.NumberInputComponent, ɵngcc3.WebsiteContentFeatureFlagDirective, ɵngcc7.InlineSVGDirective], pipes: [ɵngcc8.TranslatePipe], styles: ["button[_ngcontent-%COMP%]{font-size:.875rem}.basket-icon[_ngcontent-%COMP%]{width:15px}.btn-block[_ngcontent-%COMP%]{font-size:.875rem;min-width:172px;height:34px}"] });
MarketplaceActionsComponent.ctorParameters = () => [
    { type: MarketplaceQuery },
    { type: ErrorStateService },
    { type: NgbModal },
    { type: CartQuery },
    { type: CartService }
];
MarketplaceActionsComponent.propDecorators = {
    marketplaceItem: [{ type: Input }],
    marketplaceItemType: [{ type: Input }],
    attributeMappingID: [{ type: Input }],
    selectedAttributes: [{ type: Input }],
    validCustomFields: [{ type: Input }],
    hasECash: [{ type: Input }],
    theme: [{ type: Input }],
    actionLabels: [{ type: Input }],
    availableStock: [{ type: Input }],
    purchaseLoading: [{ type: Output }],
    hasSumbittedForm: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceActionsComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-marketplace-actions',
                template: "<div class=\"row ml-0\">\r\n  <div *ngSubscribe=\"purchaseLimit$ as purchaseLimit\" class=\"d-flex pl-0 p-0\">\r\n    <div class=\"mb-3 mb-lg-0 justify-content-center align-items-center\" *ngSubscribe=\"limitMessage$ as limitMessage\">\r\n      <ng-container *ngIf=\"marketplaceItem.Status == marketplaceItemStatus.Available\">\r\n        <fgbcl-number-input\r\n          [isActive]=\"isNumberInputActive(purchaseLimit)\"\r\n          [minValue]=\"purchaseLimit > 0 ? 1 : 0\"\r\n          [maxValue]=\"purchaseLimit\"\r\n          [incrementValue]=\"1\"\r\n          [minMessage]=\"'1 minimum'\"\r\n          [maxMessage]=\"limitMessage | translate\"\r\n          [(amount)]=\"purchaseQuantity\"\r\n          (amountChange)=\"updatePurchaseValidation(marketplaceItem)\"\r\n          [theme]=\"marketplaceItem.theme\"\r\n        >\r\n        </fgbcl-number-input>\r\n      </ng-container>\r\n    </div>\r\n\r\n    <div *ngSubscribe=\"disableCart$ as disableCart\" class=\"d-flex\">\r\n      <div class=\"\">\r\n        <button\r\n          id=\"purchase-now-button\"\r\n          [disabled]=\"disableCart\"\r\n          class=\"btn btn-marketplace-redeem btn-block font-weight-bold text-nowrap px-4 mt-lg-0\"\r\n          (click)=\"openPurchaseConfirmationModal('confirmContent')\"\r\n        >\r\n          {{ statusText | translate }}\r\n        </button>\r\n      </div>\r\n\r\n      <ng-container *fgbWebsiteContentFeatureFlag=\"'feature.flag.cart.show'\">\r\n        <div class=\"text-right\">\r\n          <button\r\n            id=\"desktop-addtocart-button\"\r\n            class=\"btn btn-marketplace-cart mt-4 px-2 mt-lg-0 d-none d-lg-block\"\r\n            (click)=\"addProductToCart()\"\r\n            [disabled]=\"disableCart\"\r\n            attr.aria-label=\"{{ 'cart.add.item.screenreader' | translate }}\"\r\n          >\r\n            <div class=\"svg svg-primary basket-icon\" [inlineSVG]=\"'assets/images/icons/add-to-basket.svg'\"></div>\r\n          </button>\r\n          <button\r\n            id=\"mobile-addtocart-button\"\r\n            class=\"btn btn-marketplace-cart mt-4 px-2 mt-lg-0 d-lg-none\"\r\n            (click)=\"addProductToCart(true)\"\r\n            [disabled]=\"disableCart\"\r\n            attr.aria-label=\"{{ 'cart.add.item.screenreader' | translate }}\"\r\n          >\r\n            <div class=\"svg svg-primary basket-icon\" [inlineSVG]=\"'assets/images/icons/add-to-basket.svg'\"></div>\r\n          </button>\r\n        </div>\r\n      </ng-container>\r\n    </div>\r\n\r\n    <div *ngIf=\"hasECash\">\r\n      <button\r\n        id=\"ecash-button\"\r\n        [disabled]=\"isEcashButtonDisabled(purchaseLimit)\"\r\n        class=\"btn btn-warning btn-block font-weight-bold\"\r\n        (click)=\"openPurchaseConfirmationModal('confirmContentCardPayment')\"\r\n      >\r\n        {{ 'marketplace.buy.with.card' | translate }}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- Server Side Errors -->\r\n<fgbcl-errors></fgbcl-errors>\r\n",
                styles: ["button{font-size:.875rem}.basket-icon{width:15px}.btn-block{font-size:.875rem;min-width:172px;height:34px}"]
            }]
    }], function () { return [{ type: ɵngcc1.MarketplaceQuery }, { type: ɵngcc1.ErrorStateService }, { type: ɵngcc2.NgbModal }, { type: ɵngcc1.CartQuery }, { type: ɵngcc1.CartService }]; }, { validCustomFields: [{
            type: Input
        }], actionLabels: [{
            type: Input
        }], purchaseLoading: [{
            type: Output
        }], hasSumbittedForm: [{
            type: Output
        }], attributeMappingID: [{
            type: Input
        }], marketplaceItem: [{
            type: Input
        }], marketplaceItemType: [{
            type: Input
        }], selectedAttributes: [{
            type: Input
        }], hasECash: [{
            type: Input
        }], theme: [{
            type: Input
        }], availableStock: [{
            type: Input
        }] }); })();

class MarketplaceActionsModule {
}
MarketplaceActionsModule.ɵfac = function MarketplaceActionsModule_Factory(t) { return new (t || MarketplaceActionsModule)(); };
MarketplaceActionsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MarketplaceActionsModule });
MarketplaceActionsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            NumberInputModule,
            DirectivesModule,
            ErrorsModule,
            InlineSVGModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MarketplaceActionsModule, { declarations: function () { return [MarketplaceActionsComponent]; }, imports: function () { return [CommonModule,
        NumberInputModule,
        DirectivesModule,
        ErrorsModule,
        InlineSVGModule, ɵngcc8.TranslateModule]; }, exports: function () { return [MarketplaceActionsComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceActionsModule, [{
        type: NgModule,
        args: [{
                declarations: [MarketplaceActionsComponent],
                imports: [
                    CommonModule,
                    NumberInputModule,
                    DirectivesModule,
                    ErrorsModule,
                    InlineSVGModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MarketplaceActionsComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MarketplaceActionsComponent, MarketplaceActionsModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-marketplace-marketplace-details-marketplace-actions.js.map